import React, { createContext, useContext } from 'react';

const ChartContext = createContext(undefined);

export const ChartProvider = ({ children, value }) => {
    return <ChartContext.Provider value={value}>{children}</ChartContext.Provider>;
};

export const useChartContext = () => {
    const context = useContext(ChartContext);
    if (context === undefined) {
        throw new Error('useChartContext 必須在 ChartProvider 中使用');
    }
    return context;
};

